import * as React from 'react';
import { useSelector } from 'react-redux';

import { Reliability } from '../../components/Reliability';
import { getNewbuildingId, isReliableSelector } from '../../selectors/newbuilding';
import { ReliabilityHousesContainer } from './ReliabilityHousesContainer';
import { trackReliableMoreClick } from './tracking';

export function ReliabilityContainer() {
  const isReliable = useSelector(isReliableSelector);
  const newbuildingId = useSelector(getNewbuildingId);

  const onReliableMoreLinkClick = React.useCallback(() => {
    trackReliableMoreClick(newbuildingId);
  }, [newbuildingId]);

  if (!isReliable) {
    return null;
  }

  return <Reliability houses={<ReliabilityHousesContainer />} onReliableMoreLinkClick={onReliableMoreLinkClick} />;
}
